"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconPriceTag = function IconPriceTag(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "m23.399 5.364 18.508 18.509a5.35 5.35 0 0 1 0 7.564l-10.09 10.09a5.35 5.35 0 0 1-7.564 0l-5.354-5.354a3.57 3.57 0 0 1-2.701 1.329L16 37.5c-3.019 0-5.292-4.092-5.486-9.712l-4.77-4.77 2.38-15.295zM11.523 25.97l14.143 14.144a3.35 3.35 0 0 0 4.587.14l.149-.14 10.09-10.09a3.35 3.35 0 0 0 0-4.736L22.7 7.495 9.875 9.475 7.876 22.322l2.706 2.706c.315-3.737 1.505-6.928 3.125-8.493a2.629 2.629 0 0 1 4.405-2.522 2.63 2.63 0 1 1-3.934 3.476c-1.394 1.548-2.482 4.753-2.654 8.48m.056 2.886c.403 4.549 2.273 7.645 4.439 7.645a2.58 2.58 0 0 0 2.167-1.04zm3.356-12.022q.074.1.164.191a1.63 1.63 0 0 0 2.3.006 1.66 1.66 0 0 0-1.237-.537L16 16.5c-.36 0-.718.116-1.064.333m2.93-.737a1.63 1.63 0 1 0-3.244-.244c.427-.229.873-.35 1.334-.35a2.63 2.63 0 0 1 1.91.594",
    clipRule: "evenodd"
  })));
};

export { IconPriceTag, IconPriceTag as default };
